const RedirectIf = ({ condition, ifComponent, elseComponent }) => {
  if (condition) {
    return ifComponent;
  }
  return elseComponent;
};

export default RedirectIf;
